import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-multi-brand-piston',
  templateUrl: './multi-brand-piston.component.html',
  styleUrls: ['./multi-brand-piston.component.scss']
})
export class MultiBrandPistonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
